import React, { Component } from 'react'
import StripeCheckout from "react-stripe-checkout"
import "./home/css/styles.css";

class CreditCard extends Component {
  onToken = (token) => {
    console.log(token)
    // fetch('/save-stripe-token', {
    //   method: 'POST',
    //   body: JSON.stringify(token),
    // }).then(response => {
    //   response.json().then(data => {
    //     alert(`We are in business, ${data.email}`);
    //   });
    // });
  }
  render() {
    return (
      <StripeCheckout
        token={this.onToken}
        stripeKey={"pk_test_51IcZtDFknmLDq2qVBMhzV5YWh9eo1PQhNV0mYHjqDUQgbrX73pkKdzLVm2DFPxbQOlBODmopDWJ9WYwJrSKKsMPm00datRBVq4"}
        shippingAddress={true}
        bitcoin={true}
      />
    )
  }
}


// import { Elements } from '@stripe/react-stripe-js';
// import { loadStripe } from '@stripe/stripe-js';

// // Make sure to call `loadStripe` outside of a component’s render to avoid
// // recreating the `Stripe` object on every render.
// const stripePromise = loadStripe('pk_test_51IcZtDFknmLDq2qVBMhzV5YWh9eo1PQhNV0mYHjqDUQgbrX73pkKdzLVm2DFPxbQOlBODmopDWJ9WYwJrSKKsMPm00datRBVq4');

// class CreditCard extends Component {
//   render() {
//     return (
//       <Elements stripe={stripePromise}>
//       </Elements>
//     );
//   };
// }

export default CreditCard
